module.exports = __webpack_public_path__ + "assets/img/password.1abe8f1c.svg";